
export default {
  name: 'SuggestionsInput',
  model: {
    prop: 'value',
    event: 'input',
  },
  props: {
    value: {
      type: String,
      default: '',
    },
    items: {
      type: Array,
      required: true,
    },
    filterKey: {
      type: String,
      required: true,
    },
    placeholder: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showSuggestions: false,
    };
  },
  computed: {
    filteredItems() {
      if (!this.value) {
        return this.items;
      }
      const searchTerm = this.value.toLowerCase();
      return this.items.filter(item =>
        item[this.filterKey].toLowerCase().includes(searchTerm)
      );
    },
  },
  methods: {
    onInput(value) {
      this.$emit('input', value);
    },
    onFocus() {
      this.showSuggestions = true;
      this.$emit('focus');
    },
    onBlur() {
      this.$emit('blur');
    },
    selectItem(item) {
      this.$emit('input', item[this.filterKey]);
      this.$emit('selection', item);
      this.showSuggestions = false;
    },
    handleClickOutside(event) {
      if (this.$refs.wrapper && !this.$refs.wrapper.contains(event.target)) {
        this.showSuggestions = false;
      }
    },
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside);
  },
};
